import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFiscalNotasFiscaisTipo } from '@/features/relatorio/page/fiscal/notas-fiscais-tipo/RelatorioFiscalNotasFiscaisTipo';

export const Route = createFileRoute('/a/relatorio/fiscal/notas-fiscais-tipo')({
    component: RelatorioFiscalNotasFiscaisTipo,
});
